/**
 * 扫码进入贷你买车入口记录
 */
import React from 'react';

import { Row, Col, DatePicker, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';

class FinancialEntranceIndex extends React.Component {

    columns = [{
        title: '用户名',
        dataIndex: 'userName',
        width: '10%',
    }, {
        title: '用户昵称',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '用户电话',
        dataIndex: 'tel',
        width: '10%',
    },{
        title: '渠道',
        dataIndex: 'origin',
        width: '10%',
    },{
        title: '进入场景',
        dataIndex: 'scene',
        width: '10%',
    }, {
        title: '访问时间',
        dataIndex: 'insertTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (field, key) =>{
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/mallLog/financialEntrance/download',
            data: queryData,
            fileName: "贷你买车入口记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange}/>
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/mallLog/financialEntrance/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default FinancialEntranceIndex;